// extracted by mini-css-extract-plugin
module.exports = {"bgDark":"styles_bgDark__TmGrZ","dark":"styles_dark__1MsFk"};